<template>
  <div class="card" :class="{orange: theme == 'orange', blue: theme == 'blue', shadow: shadow, twoCols: twoCols}">
    <slot></slot>
    <div class="content-container">
      <slot name="content"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'card',
  props: ['theme', 'shadow', 'twoCols']
}
</script>

<style lang="scss">
.card {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  height: 100%;
  box-sizing: border-box;

  .content-container {
    display: flex;
    flex-direction: column;

    div {
      width: 100%;
    }

    &.twoCols .content-container {
      flex-direction: row;
      justify-content: space-between;
    }
  }

  &.shadow {
    border: 1px solid color(border);
    -webkit-box-shadow:  0 2px 6px 0 rgba(0,0,0,0.08);
    -moz-box-shadow:  0 2px 6px 0 rgba(0,0,0,0.08);
    box-shadow: 0 2px 6px 0 rgba(0,0,0,0.08);
  }

  &.orange {
    border-top: 4px solid color(orange);
  }

  &.blue {
    border-top: 4px solid color(blue);
  }
}

</style>
